import React, { HTMLAttributes } from 'react';
import { css } from '@compiled/react';
import Marketing from '../../icons/generalMarketingOptIn.svg';

const styles = css({
  width: '48px',
  height: '48px',
});

export const MarketingIcon = (attributes: HTMLAttributes<object>) => <Marketing {...attributes} css={styles} />;

MarketingIcon.displayName = 'MarketingIcon';
